import { theme } from 'antd';

export const commonThemeSettings = {
  token: {
    colorPrimary: '#09c35c',
    borderRadius: 4,
    fontSizeBase: 14, // Sabit font boyutu
    fontSizeLG: 14, // Sabit büyük font boyutu
    fontSizeSM: 14, // Sabit küçük font boyutu
    paddingXS: 8,
    paddingSM: 8,
    paddingMD: 8,
    paddingLG: 8,
    lineHeightBase: 1.5,
    lineHeightLG: 1.5,
    lineHeightSM: 1.5,
  },
  components: {
    Input: {
      colorPrimary: '#eb2f96',
      hoverBorderColor: '#09c35c',
      activeBorderColor: '#09c35c',
      borderRadius: 4,
      fontSize: 14, // Sabit Input font boyutu
      lineHeight: 1.5, // Sabit Input line height
      paddingHorizontal: 8, // Sabit Input padding
      paddingVertical: 4,
      border: 12
    },
    Button: {
      colorPrimary: '#09c35c',
      fontSize: 14, // Sabit Button font boyutu
      lineHeight: 1.5, // Sabit Button line height
      paddingHorizontal: 16, // Sabit Button padding
      paddingVertical: 8,
    },
    Table: {
      borderColor: '#d9d9d9',
      fontSize: 14, // Sabit Table font boyutu
      lineHeight: 1.5, // Sabit Table line height
      padding: 16, // Sabit Table padding
    },
    Form: {
      labelFontSize: 14,
      itemMarginBottom: 14,
      inlineItemMarginBottom: 0,
    },
    Drawer: {
      // Drawer bileşeni için ortak ayarlar
    },
    Menu: {
      darkItemBg: "#fffff"
    }
  },
};